module.exports = __webpack_public_path__ + "img/18.1feb1373.jpg";